import { CardContent as MuiCardContent, Card as MuiCard, Typography, Box, Fade } from "@material-ui/core";
import styled from "styled-components/macro";
import DoughnutChart from "./components/DoughnutChart";
import TableStats from "./components/TableStats";
import React, { FC } from "react";
import NoDataAvailable from "./components/NoDataAvailable";
import Loading from "./components/Loading";
import { useTranslation } from "react-i18next";

const Card = styled(MuiCard)`
      border-radius: 14px
    `;
const CardContent = styled(MuiCardContent)`
      position: relative;
      height:371px;
      padding: 0
    `;

type PropsType = {
  data: Array<{
    name: string,
    value: number
  }>,
}

const NumberOfUnits:FC<PropsType> = ({data}) => {
  const { t } = useTranslation();

  const haveData = () => {
    return data && data.every(
      (item) => Object.values(item).every(
        (itemObj) => itemObj !== 0)
    )
  }

  const tableData = {
    heads: [
      t("statsPage_unit"),
      t("statsPage_amount")
    ],
    rows: haveData() ? data.map(
      (i) => {
        i.name = t(i.name)
        return i
      }) : []
  }

  const doughnutData = {
    labels: [
      t("statsPage_accessible"),
      t("statsPage_notAccessible")
    ],
    data: tableData.rows.map((i) => i.value)
  }

  return (
    <Fade in={true}>
      <Card>
        <CardContent>
          <Box p={4}>
            <Typography>
              {t("statsPage_numberOfUnits")}
            </Typography>
          </Box>
          <Loading loading={!data}>
            <Box>
              <Box mb={8} mt={4}>
                <DoughnutChart
                  labels={doughnutData.labels}
                  data={doughnutData.data}
                />
              </Box>
              <TableStats
                headNames={tableData.heads}
                rows={tableData.rows}
                height={145}
              />
              <NoDataAvailable visible={!haveData()}/>
            </Box>
          </Loading>
        </CardContent>
      </Card>
    </Fade>
  )
}
export default NumberOfUnits
